export default function blogSearchResults (document, moduleHTML, appEventEmitter) {
  const params = new URLSearchParams(window.location.search)
  const searchQueryValue = params.get('q')
  const action = `${process.env.GATSBY_API_URL}/blog-search?q=${searchQueryValue}`
  const blogItemsWrapper = document.querySelector('[data-js-blog-search-results]')

  window.addEventListener('load', (event) => {
    fetch(action, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (r) {
      return r.json()
    }).then(function (data) {
      if (data.response.length) {
        return data.response.map(function (item) {
          const blogItem = blogItemsWrapper.querySelector('div').cloneNode(true)
          const webpSource = blogItem.querySelector('source[type="image/webp"]')
          const imgSource = blogItem.querySelector('source:not([type="image/webp"])')
          const img = blogItem.querySelector('img')
          const blogUrl = blogItem.querySelector('[data-js-post-url]')
          const metaDesc = blogItem.querySelector('[data-js-post-description]')
          const postAuthor = blogItem.querySelector('[data-js-post-author]')
          const postAuthorAnchor = postAuthor.querySelector('a')

          webpSource.srcset = item.display_image_webp_src
          imgSource.srcset = item.display_image_src
          img.src = item.display_image_src
          img.alt = item.display_image_alt
          blogUrl.href = item.page_url
          blogUrl.innerHTML = item.title
          if (metaDesc) {
            metaDesc.innerHTML = item.metadata_description
          }
          postAuthorAnchor.href = item.author_url
          postAuthorAnchor.innerHTML = item.author
          if (!item.author_url) {
            postAuthorAnchor.remove()
            postAuthor.innerHTML += item.author
          }

          blogItemsWrapper.append(blogItem)
        })
      } else {
        return document.querySelector('[data-js-no-blog-results]').classList.remove('hidden')
      }
    }).then(function () {
      ['hidden', 'flex'].forEach((className) => blogItemsWrapper.classList.toggle(className))
      blogItemsWrapper.querySelector('div').remove()
    })
  })
}
